import { ProformaInvoiceConstants } from "../constants/proformainvoice.constants";

const ProformaInvoiceReducer = (state, action) => {
  switch (action.type) {
    case ProformaInvoiceConstants.FETCH_PROFORMA_INVOICE_REQUEST:
      return {
        ...state,
        isLoading: true,
        hasError: false,
      };
    case ProformaInvoiceConstants.FETCH_PROFORMA_INVOICE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        proformaInvoices: action.payload.data,
        paging: action.payload.paging,
      };
    case ProformaInvoiceConstants.FETCH_PROFORMA_INVOICE_FAILURE:
      return {
        ...state,
        hasError: true,
        isLoading: false,
      };

    case ProformaInvoiceConstants.PROFORMA_INVOICE_SEARCH_REQUEST:
      return {
        ...state,
        isLoading: true,
        hasError: false,
      };
    case ProformaInvoiceConstants.PROFORMA_INVOICE_SEARCH_SUCCESS:
      return {
        ...state,
        isLoading: false,
        proformaInvoiceSearchResults: action.payload,
      };
    case ProformaInvoiceConstants.PROFORMA_INVOICE_SEARCH_FAILURE:
      return {
        ...state,
        hasError: true,
        isLoading: false,
      };

    case ProformaInvoiceConstants.PROFORMA_INVOICE_AUTO_SEARCH_REQUEST:
      return {
        ...state,
        isLoading: true,
        hasError: false,
      };
    case ProformaInvoiceConstants.PROFORMA_INVOICE_AUTO_SEARCH_SUCCESS:
      return {
        ...state,
        isLoading: false,
        proformaInvoiceAutoSearchResults: action.payload,
      };
    case ProformaInvoiceConstants.PROFORMA_INVOICE_AUTO_SEARCH_FAILURE:
      return {
        ...state,
        hasError: true,
        isLoading: false,
      };

    case ProformaInvoiceConstants.ADD_PROFORMA_INVOICE_REQUEST:
      return {
        ...state,
        isSubmitting: true,
        hasError: false,
      };
    case ProformaInvoiceConstants.ADD_PROFORMA_INVOICE_SUCCESS:
      return {
        ...state,
        isSubmitting: false,
      };
    case ProformaInvoiceConstants.ADD_PROFORMA_INVOICE_FAILURE:
      return {
        ...state,
        hasError: true,
        isSubmitting: false,
        errorMessage: action.payload.message,
      };

    case ProformaInvoiceConstants.GET_PROFORMA_INVOICE_REQUEST:
      return {
        ...state,
        isLoading: true,
        hasError: false,
      };
    case ProformaInvoiceConstants.GET_PROFORMA_INVOICE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        proformaInvoice: action.payload,
      };
    case ProformaInvoiceConstants.GET_PROFORMA_INVOICE_FAILURE:
      return {
        ...state,
        hasError: true,
        isLoading: false,
      };

    case ProformaInvoiceConstants.UPDATE_PROFORMA_INVOICE_REQUEST:
      return {
        ...state,
        isSubmitting: true,
        hasError: false,
      };
    case ProformaInvoiceConstants.UPDATE_PROFORMA_INVOICE_SUCCESS:
      return {
        ...state,
        isSubmitting: false,
        proformaInvoice: action.payload,
      };
    case ProformaInvoiceConstants.UPDATE_PROFORMA_INVOICE_FAILURE:
      return {
        ...state,
        hasError: true,
        isSubmitting: false,
      };
    case ProformaInvoiceConstants.DOWNLOAD_PROFORMA_INVOICE_REQUEST:
      console.log("action33333333", action.payload);
      return {
        ...state,
        isLoadingDownload: true,
        hasError: false,
        downloadFileType: action.payload.fileType,
      };
    case ProformaInvoiceConstants.DOWNLOAD_PROFORMA_INVOICE_SUCCESS:
      return {
        ...state,
        isLoadingDownload: false,
        downloadFileType: "",
      };
    case ProformaInvoiceConstants.DOWNLOAD_PROFORMA_INVOICE_FAILURE:
      return {
        ...state,
        hasError: true,
        isLoadingDownload: false,
        downloadFileType: "",
      };
    case ProformaInvoiceConstants.UPLOAD_PROFORMA_INVOICE_REQUEST:
      return {
        ...state,
        isUpload: true,
        uploadError: false,
      };
    case ProformaInvoiceConstants.UPLOAD_PROFORMA_INVOICE_SUCCESS:
      return {
        ...state,
        uploadSuccess: true,
        uploadError: false,
        isUpload: false,
      };
    case ProformaInvoiceConstants.UPLOAD_PROFORMA_INVOICE_FAILURE:
      return {
        ...state,
        uploadError: true,
        isUpload: false,
      };

    default:
      return state;
  }
};

export default ProformaInvoiceReducer;
